import { Component, ErrorInfo, ReactNode } from 'react';
import { Location } from 'react-router-dom';
import { ErrorComponent } from '../../components/error/ErrorComponent';

interface ErrorBoundaryProps {
  children: ReactNode;
  location: Location;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public componentDidMount() {
    if (this.state.hasError) {
      this.setState({
        hasError: false,
      });
    }
  }

  public componentDidUpdate(prevProps: ErrorBoundaryProps) {
    /**
     * Listening for updates on location
     *
     * Updating "hasError" state if location changes and "hasError" is previously "true"
     */
    if (prevProps.location !== this.props.location && this.state.hasError) {
      this.setState({
        hasError: false,
      });
    }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught Error: ', error, errorInfo);
  }

  public render(): ReactNode {
    return this.state.hasError ? <ErrorComponent /> : this.props.children;
  }
}
